export default {
  app: {
    featured: 'แนะนำ',
    random: 'สุ่ม',
    explore: 'ค้นหา',
    keywords: 'คำค้น',
    search: 'ค้นหา',
  },
  explore: {
    filters: 'คัดกรอง',
    resetFilters: 'ลบตัวคัดกรอง',
    addKeyword: 'ใส่คีย์เวิร์ด',
  },
  recipe: {
    contributedBy: 'ร่วมสนับสนุนโดย',
    ingredients: 'ส่วนประกอบ',
    directions: 'ขั้นตอน',
    fullRecipe: 'ดูสูตรทั้งหมด',
    similarDrinks: 'เครื่องดื่มที่คล้ายกัน',
  },
  featuredRecipes: {
    loadMore: 'โหลดเพิ่มเติม',
  },
  recipeFind: {
    filterBy: 'คัดกรองโดย',
    name: 'ชื่อ',
    ingredients: 'ส่วนประกอบ',
    keywords: 'คำค้นหาสำคัญ',
    searchForIngredients: 'คุณสามารถค้นหาด้วยส่วนประอบหลายอย่างโดยใช้เว้นวรรคแยกคำ',
    searchForKeywords: 'คุณสามารถค้นหาด้วยคีย์เวิร์ดหลายตัวโดยใช้เว้นวรรคแยกคำ',
  },
  recipeList: {
    viewRecipe: 'ดูสูตร',
  },
  recipeToolbar: {
    print: 'พิมพ์',
    share: 'แชร์',
    shareOnFacebook: 'Facebook',
    shareOnTwitter: 'Twitter',
    copyURL: 'คัดลอกลิ้งค',
    hideImage: 'ซ่อนรูป',
  },
  favorites: {
    removeAllFavorites: 'ลบของที่ชอบทั้งหมด',
    noFavoriteDrinks: 'คุณไม่มีเครื่องดื่มที่ชอบ',
    removeFavoritesPrompt: 'คุณแน่ใจว่าจะลบของที่ชอบทั้งหมด?',
    delete: 'ลบ',
    cancel: 'ยกเลิก',
  },
  keywordList: {
    enterYourKeyword: 'ใส่คำค้นหา',
  },
  search: {
    findYourDrink: 'หาเครื่องดื่มของคุณ',
  },
  pageNotFound: {
    pageNotFound: 'ไม่พบหน้าที่คุณต้องการดู',
    backToHome: 'กลับไปหน้าแรก',
  },
};
